// extracted by mini-css-extract-plugin
export default {"revenueCards":"styles_revenueCards__1vYCV"};